import { render, staticRenderFns } from "./editTelegram.vue?vue&type=template&id=f6b5bfc4&scoped=true&"
import script from "./editTelegram.vue?vue&type=script&lang=js&"
export * from "./editTelegram.vue?vue&type=script&lang=js&"
import style0 from "./editTelegram.vue?vue&type=style&index=0&id=f6b5bfc4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b5bfc4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VForm,VRow})
